 document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/search')) return;

  const searchWrapper = document.getElementById('HeaderSearch');
  if (!searchWrapper) return;

  const searchBox = searchWrapper.querySelector('.search-box');
  const searchInput = searchWrapper.querySelector('input[type="search"]');
  const resultsWrapper = searchWrapper.querySelector('.predictive-results');
  const resultsContainer = searchWrapper.querySelector('.predictive-search-results');
  const emptyState = searchWrapper.querySelector('.search-empty-state');

  /* =========================
     OPEN / CLOSE SEARCH
  ========================= */

  let scrollPosition = 0;

  const openSearch = () => {
    scrollPosition = window.scrollY;

    document.body.classList.add('search-open');
    document.body.style.top = `-${scrollPosition}px`;

    searchWrapper.classList.add('active');
    searchInput?.focus();

    if (emptyState) emptyState.style.display = 'block';
  };

  const closeSearch = () => {
    document.body.classList.remove('search-open');
    document.body.style.top = '';

    window.scrollTo(0, scrollPosition);

    searchWrapper.classList.remove('active');

    searchInput.value = '';
    if (resultsContainer) resultsContainer.innerHTML = '';
    if (emptyState) emptyState.style.display = 'block';
  };



document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.js-header-search');
  if (!toggle) return;

  e.preventDefault();
  e.stopPropagation();
  openSearch();
}, true); 


  searchWrapper.addEventListener('click', (e) => {
    if (!searchBox) return;
    if (!searchBox.contains(e.target)) closeSearch();
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-close]')) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  /* =========================
     PREDICTIVE SEARCH
  ========================= */

 class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
  }

  connectedCallback() {
    if (!this.input) return;
    this.input.addEventListener('input', this.onInput.bind(this));
  }

  onInput() {
    const term = this.input.value.trim();

    if (term.length < 1) {
      if (resultsContainer) resultsContainer.innerHTML = '';
      resultsWrapper.classList.remove('active');
      if (emptyState) emptyState.style.display = 'block';

      this.trapFocus();   
      return;
    }

    if (emptyState) emptyState.style.display = 'none';

    fetch(
      `/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article&section_id=predictive-search`
    )
      .then(res => res.text())
      .then(html => { 
        if (!resultsContainer) return; 

        const term = searchInput.value.trim();
        const trimmedHtml = html.replace(/\s+/g, '');

        if (trimmedHtml.length > 0) {
          resultsContainer.innerHTML = html; 
          resultsWrapper.classList.add('active'); 
        } else {
          resultsContainer.innerHTML = `<p class="no-results">No results found for "<strong>${term}</strong>"</p>`;
          resultsWrapper.classList.add('active');
        }

        if (emptyState) emptyState.style.display = 'none';

        this.trapFocus(); 
      });
  }

  trapFocus() {

  this.removeEventListener(
    'keydown',
    this.handleKeydown
  );

  const getFocusableElements = () => {

    return Array.from(
      this.querySelectorAll(
        'button, a[href], input:not([type="hidden"]), select, textarea, [tabindex]'
      )
    ).filter((el) => {

      if (el.hasAttribute('disabled')) {
        return false;
      }

      if (el.hasAttribute('tab_index_minus')) {
        el.setAttribute('tabindex', '-1');
        return false;
      }

      if (el.hasAttribute('focus_enabled')) {
        el.setAttribute('tabindex', '0');
      }

      if (el.getAttribute('tabindex') === '-1') {
        return false;
      }

      if (
        el.closest('[hidden]') ||
        el.closest('.hidden') ||
        el.closest('.search-tab-panel:not(.active)')
      ) {
        return false;
      }

      const style = window.getComputedStyle(el);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        (
          el.offsetWidth > 0 ||
          el.offsetHeight > 0 ||
          el.getClientRects().length > 0
        )
      );
    });

  };

  this.handleKeydown = (e) => {

    if (e.key !== 'Tab') return;

    const focusable =
      getFocusableElements();

    if (!focusable.length) return;

    const firstEl =
      focusable[0];

    const lastEl =
      focusable[
        focusable.length - 1
      ];

    if (
      e.shiftKey &&
      document.activeElement === firstEl
    ) {

      e.preventDefault();
      lastEl.focus();

    } else if (
      !e.shiftKey &&
      document.activeElement === lastEl
    ) {

      e.preventDefault();
      firstEl.focus();

    }

  };

  this.addEventListener(
    'keydown',
    this.handleKeydown
  );

}
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
  /* =========================
     CLEAR SEARCH INPUT
  ========================= */

  document.addEventListener('click', (e) => {
    const clearBtn = e.target.closest('.search-clear');
    if (!clearBtn) return;

    searchInput.value = '';
    searchInput.focus();

    if (resultsContainer) resultsContainer.innerHTML = '';
    resultsWrapper.classList.remove('active');

    if (emptyState) emptyState.style.display = 'block';
  });

  /* =========================
     SEARCH PAGE REDIRECT
  ========================= */

  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const term = searchInput.value.trim();
      if (!term) {
        e.preventDefault();
        return;
      }

      window.location.href = `/search?q=${encodeURIComponent(term)}`;
    }
  });
});


class SearchTab extends HTMLElement {

  connectedCallback() {

    this.buttons =
      this.querySelectorAll(
        '.search-tab-btn'
      );

    this.panels =
      this.querySelectorAll(
        '.search-tab-panel'
      );

    this.buttons.forEach((button) => {

      button.addEventListener(
        'click',
        () => {

          const tab =
            button.dataset.tab;

          this.buttons.forEach((btn) => {
            btn.classList.remove('active');
          });

          this.panels.forEach((panel) => {
            panel.classList.remove('active');
          });

          button.classList.add('active');

          this.querySelector(
            `[data-panel="${tab}"]`
          )?.classList.add('active');

        }
      );

    });

  }

}

customElements.define(
  'search-tab',
  SearchTab
);